/** @jsxImportSource @emotion/react */
import { modList } from 'components/landing/settings';

const ScreenshotStatus = ({ currentModuleId }) => {
  const set = modList[currentModuleId].statusScreenshot;

  return (
    <div
      css={{
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
        marginTop: 30,
        marginBottom: 30,
        '@media (min-width:992px)': { justifyContent: 'flex-start' },
      }}
    >
      <img srcSet={set} css={{ filter: `drop-shadow(-42px 39px 14px rgb(117 117 117 / 25%))` }} />
    </div>
  );
};

export default ScreenshotStatus;
